import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import statsReducer from "./reducers/statsReducer";

const reducer = combineReducers({
    statistics: statsReducer
});

const store = configureStore({
  reducer,
});

export default store;
